import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDraft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <mask
      id="a"
      width={20}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="currentColor"
        d="M5.554 18.17c-.48 0-.886-.17-1.221-.506a1.672 1.672 0 0 1-.502-1.224V3.56c0-.48.168-.887.505-1.224a1.667 1.667 0 0 1 1.224-.505h5.79a1.677 1.677 0 0 1 1.227.507l3.085 3.085a1.676 1.676 0 0 1 .507 1.227v9.79c0 .479-.168.887-.505 1.224a1.668 1.668 0 0 1-1.225.505zM10.94 6.194V3.56H5.56v12.88h8.88V7.06h-2.635a.836.836 0 0 1-.614-.25.835.835 0 0 1-.25-.615"
      />
    </g>
  </svg>
);
export default SvgDraft;
